/**
 * The five-dot mark (BRAND.md §1). Canonical geometry, one <ellipse> per dot, no
 * plate, no Z line. Colour follows currentColor. Static in the app: the pulse is
 * reserved for loading screens and the landing hero (one moving element per page).
 */
export function Mark({ size = 28, pulse = false, title }: { size?: number; pulse?: boolean; title?: string }) {
  return (
    <svg
      className={`z-mark${pulse ? " z-mark-pulse" : ""}`}
      viewBox="213 216 1174 1174"
      width={size}
      height={size}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      fill="currentColor"
    >
      <ellipse cx="410" cy="410" rx="184" ry="194" />
      <ellipse cx="1190" cy="410" rx="184" ry="194" />
      <ellipse cx="800" cy="800" rx="184" ry="194" />
      <ellipse cx="410" cy="1190" rx="186" ry="200" />
      <ellipse cx="1190" cy="1190" rx="186" ry="200" />
    </svg>
  );
}

export function Wordmark({ size = 28 }: { size?: number }) {
  return (
    <span
      style={{ display: "inline-flex", alignItems: "center", gap: 10, color: "var(--z-brand)" }}
      aria-label="Zerpid"
    >
      <Mark size={size} />
      <span style={{ fontWeight: 800, fontSize: size * 0.72, letterSpacing: "-0.02em", color: "var(--z-ink)" }}>
        Zerpid
      </span>
    </span>
  );
}
